import {
	Badge,
	Box,
	Flex,
	Heading,
	HStack,
	Icon,
	List,
	ListIcon,
	ListItem,
	SimpleGrid,
	Text,
	VStack
} from "@chakra-ui/react";
import { FaBullhorn, FaGift, FaMoneyBillWave, FaCheckCircle } from "react-icons/fa";
import FullScreenSection from "./FullScreenSection";
import JoinCampaign from "./JoinCampaign";

const campaigns = [
	{
		title: "New User Campaign",
		badge: "Limited-time",
		icon: FaGift,
		color: "purple.500",
		headline: "Earn $50 on your first $1,000 cross-border transfer",
		description:
			"Get rewarded when you make your first qualifying transfer. The bonus is credited after eligibility requirements are met.",
		terms: [
			"Be a Swiftchang customer",
			"Maintain an active account for at least 3 months",
			"Complete a minimum of 1 transfer each month"
		]
	},
	{
		title: "Everyday Cashback",
		badge: "Always on",
		icon: FaMoneyBillWave,
		color: "green.500",
		headline: "Earn 1% cashback on any transfer above $100",
		description:
			"All users qualify automatically. Cashback applies to eligible transfers over $100 and is credited to your account.",
		terms: [
			"Available to all users",
			"Applies to transfers over $100",
			"Cashback is credited automatically"
		]
	}
];

export default function Promotion() {
	return (
        <VStack spacing={0} width="100%">   
            <FullScreenSection
                justifyContent="center"
                alignItems="center"
                isDarkBackground={false}
                backgroundColor="gray.50"
                py={100}
            >
                <VStack spacing={12} maxW="1200px" width="100%">
                    <VStack spacing={4} textAlign="center" maxW="900px">
                        <HStack spacing={3} justify="center">
                            <Icon as={FaBullhorn} boxSize={10} color="black.500" />
                            <Heading fontSize={{ base: "2.2rem", md: "3rem" }} fontWeight="bold">
                                Campaigns & Promotions
                            </Heading>
                        </HStack>
                        <Text fontSize="1.2rem" color="gray.600" lineHeight="1.8">
                            Stay updated on the latest campaigns and promotions for awesome ways to get even more from Swiftchang.
                        </Text>
                    </VStack>

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} width="100%">
                        {campaigns.map((campaign) => (
                            <Box
                                key={campaign.title}
                                bg="white"
                                borderRadius="xl"
                                boxShadow="lg"
                                p={{ base: 6, md: 8 }}
                                border="2px solid"
                                borderColor="gray.200"
                                transition="all 0.3s ease"
                                _hover={{ transform: "translateY(-6px)", boxShadow: "2xl", borderColor: campaign.color }}
                            >
                                <Flex align="center" justify="space-between" mb={4} flexWrap="wrap" gap={3}>
                                    <HStack spacing={3}>
                                        <Icon as={campaign.icon} boxSize={9} color={campaign.color} />
                                        <Heading fontSize="1.6rem">{campaign.title}</Heading>
                                    </HStack>
                                    <Badge colorScheme="blue" variant="subtle" px={3} py={1} borderRadius="full">
                                        {campaign.badge}
                                    </Badge>
                                </Flex>

                                <Text fontSize="1.1rem" fontWeight="semibold" color="gray.800" mb={3}>
                                    {campaign.headline}
                                </Text>
                                <Text color="gray.600" lineHeight="1.8" mb={5}>
                                    {campaign.description}
                                </Text>

                                <Box bg="gray.50" borderRadius="lg" p={4}>
                                    <Text fontWeight="semibold" color="gray.700" mb={3}>
                                        Terms & Conditions
                                    </Text>
                                    <List spacing={2} color="gray.600">
                                        {campaign.terms.map((term) => (
                                            <ListItem key={term}>
                                                <ListIcon as={FaCheckCircle} color={campaign.color} />
                                                {term}
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            </Box>
                        ))}
                    </SimpleGrid>
                </VStack>
            </FullScreenSection>
             
            <JoinCampaign />
                
        </VStack>
	);
}
